import { createWidget } from '@alfa-bank/site-util-create-widget/create-widget';
import { Sticky } from '@alfa-bank/site-sticky';
import { X5BankButton } from '@alfa-bank/site-x5-bank-button';
import { TextHolder } from '@alfa-bank/site-text-holder';
import { Aligner } from '@alfa-bank/site-aligner';
import { BackgroundV2 } from '@alfa-bank/site-background-v2';

import { StickyMobile as Component } from './sticky-mobile';
import type { IDeps, TStickyMobile } from './models';
import styles from './styles.css';

export const StickyMobile = createWidget<IDeps, TStickyMobile>({
    Sticky,
    X5BankButton,
    BackgroundV2,
    Aligner,
    TextHolder,
    styles,
})(Component);
